var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSstPhsLogoRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.39,
    height: 84.96,
    viewBox: "0 0 155.39 84.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sst_phs_logo_rgb",
    transform: "translate(-3.72 -6.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1",
    "data-name": "Gruppe 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    "data-name": "Pfad 1",
    d: "M8.98,57.71c2.78,0,6.15,1.35,6.15,5.05s-3.35,5.1-6.15,5.1H7.44v5.92H3.72V57.7H8.98ZM7.44,64.78H8.45c1.58,0,2.73-.51,2.73-1.95a2.041,2.041,0,0,0-2.3-2.04H7.43v4Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2",
    "data-name": "Pfad 2",
    d: "M21.14,64.51v9.28H17.42V64.51H16.11V61.48h1.31v-.71a4.8,4.8,0,0,1,.94-3.28,4.358,4.358,0,0,1,3.51-1.19,7.392,7.392,0,0,1,2.25.34l-.57,3.01a3.539,3.539,0,0,0-1.33-.23c-.5,0-.73.14-.87.39a2.518,2.518,0,0,0-.21,1.15v.53H24.1v3.03H21.14Zm8.08,9.28H25.5V56.57h3.72Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    "data-name": "Pfad 3",
    d: "M37.63,74.07a5.974,5.974,0,0,1-6.27-6.25,6.328,6.328,0,0,1,6.29-6.61c3.58,0,6.04,2.39,6.04,5.67a11.573,11.573,0,0,1-.16,1.68h-8.4a2.752,2.752,0,0,0,2.76,2.57,3.4,3.4,0,0,0,3.05-1.77l2.39,1.63A6.3,6.3,0,0,1,37.63,74.07Zm2.3-7.95a2.025,2.025,0,0,0-2.16-2.07,2.426,2.426,0,0,0-2.5,2.07Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    "data-name": "Pfad 4",
    d: "M57.9,73.22a6.178,6.178,0,0,1-.83,3.28,6.053,6.053,0,0,1-5.4,2.62,10.758,10.758,0,0,1-5.76-1.72l1.35-3.01A7.325,7.325,0,0,0,51.55,76a2.4,2.4,0,0,0,2.62-2.64v-.99a4.617,4.617,0,0,1-3.51,1.42c-3.17,0-5.58-2.78-5.58-6.34s2.41-6.25,5.6-6.25a4.315,4.315,0,0,1,3.72,1.77l.37-1.49h3.12V73.21ZM54.18,65.5a3.2,3.2,0,0,0-2.59-1.17c-1.86,0-2.73,1.63-2.73,3.22a2.881,2.881,0,0,0,2.69,3.12,2.975,2.975,0,0,0,2.64-1.38V65.5Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    "data-name": "Pfad 5",
    d: "M66.21,74.07a5.974,5.974,0,0,1-6.27-6.25,6.328,6.328,0,0,1,6.29-6.61c3.58,0,6.04,2.39,6.04,5.67a11.573,11.573,0,0,1-.16,1.68h-8.4a2.752,2.752,0,0,0,2.76,2.57,3.4,3.4,0,0,0,3.05-1.77l2.39,1.63A6.3,6.3,0,0,1,66.21,74.07Zm2.3-7.95a2.025,2.025,0,0,0-2.16-2.07,2.426,2.426,0,0,0-2.5,2.07h4.66Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    "data-name": "Pfad 6",
    d: "M78.15,62.74a4.636,4.636,0,0,1,3.49-1.54,4.262,4.262,0,0,1,3.17,1.63c1.01,1.29,1.1,2.85,1.1,4.57v6.38H82.19V67.53a6.388,6.388,0,0,0-.28-2.37,1.492,1.492,0,0,0-1.47-.85,2.785,2.785,0,0,0-2.3,1.29v8.18H74.42V56.56h3.72v6.18Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    "data-name": "Pfad 7",
    d: "M88.7,60.01V57.07h3.72v2.94Zm0,13.78V61.48h3.72V73.79Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    "data-name": "Pfad 8",
    d: "M99.04,73.79H95.32V56.57h3.72Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9",
    "data-name": "Pfad 9",
    d: "M108.82,59.85a3.471,3.471,0,0,0-1.77-.44c-.48,0-.73.14-.87.39a2.518,2.518,0,0,0-.21,1.15v.53h2.96v3.03h-2.96v9.28h-3.72V64.51h-1.31V61.48h1.31v-.71a4.8,4.8,0,0,1,.94-3.28,4.358,4.358,0,0,1,3.51-1.19,7.31,7.31,0,0,1,3.28.76l-1.17,2.8Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10",
    "data-name": "Pfad 10",
    d: "M115.84,74.07a5.974,5.974,0,0,1-6.27-6.25,6.328,6.328,0,0,1,6.29-6.61c3.58,0,6.04,2.39,6.04,5.67a11.573,11.573,0,0,1-.16,1.68h-8.4a2.752,2.752,0,0,0,2.76,2.57,3.4,3.4,0,0,0,3.05-1.77l2.39,1.63a6.3,6.3,0,0,1-5.7,3.08Zm2.3-7.95a2.025,2.025,0,0,0-2.16-2.07,2.426,2.426,0,0,0-2.5,2.07Z",
    fill: "#f59f40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2",
    "data-name": "Gruppe 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11",
    "data-name": "Pfad 11",
    d: "M129.78,60.56c-.85,0-1.75.46-1.75,1.38,0,1.17,1.45,1.45,2.48,1.81,2.27.78,5.05,1.84,5.05,5.35s-3.31,4.96-6.25,4.96a8.448,8.448,0,0,1-6.27-2.8l2.41-2.37c1.24,1.15,2.18,2.04,3.9,2.04,1.13,0,2.25-.53,2.25-1.77s-1.49-1.77-2.94-2.3c-2.14-.8-4.36-1.81-4.36-4.91s2.73-4.5,5.42-4.5a8.64,8.64,0,0,1,5.47,1.97l-2.09,2.62a5.472,5.472,0,0,0-3.33-1.49Z",
    fill: "#74c9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12",
    "data-name": "Pfad 12",
    d: "M143.55,74.07a5.974,5.974,0,0,1-6.27-6.25,6.328,6.328,0,0,1,6.29-6.61c3.58,0,6.04,2.39,6.04,5.67a11.574,11.574,0,0,1-.16,1.68h-8.41a2.752,2.752,0,0,0,2.76,2.57,3.4,3.4,0,0,0,3.05-1.77l2.39,1.63a6.3,6.3,0,0,1-5.7,3.08Zm2.3-7.95a2.025,2.025,0,0,0-2.16-2.07,2.426,2.426,0,0,0-2.5,2.07Z",
    fill: "#74c9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    "data-name": "Pfad 13",
    d: "M155.69,64.51v4.5a5.706,5.706,0,0,0,.07,1.1c.09.51.32.83.85.83a2.582,2.582,0,0,0,1.33-.34l1.17,2.71a6.742,6.742,0,0,1-3.17.76,3.66,3.66,0,0,1-3.81-2.87,8.548,8.548,0,0,1-.16-1.91V64.51h-1.4V61.48h1.4l.69-2.64h3.03v2.64h3.03v3.03h-3.03Z",
    fill: "#74c9e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3",
    "data-name": "Gruppe 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14",
    "data-name": "Pfad 14",
    d: "M75.6,34.49a1,1,0,0,1-.9-.57L69.71,23.53c-.25-.54-.36-.64-.8-.75L52.98,19.31l7.23,11.94a1,1,0,1,1-1.71,1.03L50.06,18.35a1,1,0,0,1,1.07-1.5l18.22,3.97a2.9,2.9,0,0,1,2.17,1.84l4.99,10.39a.99.99,0,0,1-.47,1.33.965.965,0,0,1-.43.1Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M79.08,32.73a1.014,1.014,0,0,1-.97-.74L74.36,17.85a1.854,1.854,0,0,0-.16-.57L56.45,14.12l.31,1.02a1,1,0,1,1-1.92.58l-.74-2.43a1.2,1.2,0,0,1-.06-.24.985.985,0,0,1,.26-.9,1,1,0,0,1,.9-.29l19.41,3.48c.93.17,1.5.87,1.71,2.08l3.73,14.05a1,1,0,0,1-.71,1.22,1.153,1.153,0,0,1-.26.03Z",
    fill: "#f59f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M79.99,32.38h-.12a1,1,0,0,1-.88-1.11l2.09-17.9c.06-.44.03-.48-.4-.55L68.72,10.93a1,1,0,0,1-.81-.72l-.36-1.29L61.6,8.13l-.11,1.62a1,1,0,1,1-2-.14l.15-2.23a1.7,1.7,0,0,1,.19-.83.922.922,0,0,1,.43-.42,1.173,1.173,0,0,1,.64-.1l7.56,1.01a1,1,0,0,1,.83.72l.36,1.31,11.33,1.79a2.286,2.286,0,0,1,2.07,2.77L80.96,31.52a1,1,0,0,1-.99.88Z",
    fill: "#f59f40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4",
    "data-name": "Gruppe 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M77.03,48.05a2.758,2.758,0,0,1-1.09-.22L60.32,41.18a2.831,2.831,0,0,1-1.57-3.48l.43-1.29a2.719,2.719,0,0,1,1.4-1.61,2.765,2.765,0,0,1,2.13-.14L71,37.5a2.767,2.767,0,0,1,1.52-3.06l14.62-7.02a2.732,2.732,0,0,1,2.1-.12l16.79,5.75a2.832,2.832,0,0,1,1.76,3.55l-3.11,9.39-6.74-3.77a1.806,1.806,0,0,0-1.4-.15L77.87,47.93a2.935,2.935,0,0,1-.83.13ZM61.8,35.5a1.747,1.747,0,0,0-1.67,1.21L59.7,38a1.833,1.833,0,0,0,1.01,2.25L76.33,46.9a1.794,1.794,0,0,0,1.23.06L96.23,41.1a2.794,2.794,0,0,1,2.19.23l5.68,3.18,2.73-8.24a1.825,1.825,0,0,0-1.14-2.29L88.9,28.23a1.779,1.779,0,0,0-1.34.08L72.94,35.33a1.806,1.806,0,0,0,1.41,3.32l11.61-4.33.35.94L74.7,39.59a2.747,2.747,0,0,1-2.21-.12,2.841,2.841,0,0,1-.98-.81l-.02.06L62.37,35.6a1.91,1.91,0,0,0-.58-.1Z",
    fill: "#74c9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    d: "M77.03,48.55a3.377,3.377,0,0,1-1.29-.26L60.12,41.64a3.334,3.334,0,0,1-1.85-4.1l.43-1.29a3.279,3.279,0,0,1,1.65-1.91,3.223,3.223,0,0,1,2.51-.16l7.57,2.59a3.276,3.276,0,0,1,1.86-2.8l14.62-7.02a3.329,3.329,0,0,1,2.48-.15l16.79,5.75a3.327,3.327,0,0,1,2.07,4.18l-2.92,8.82a1.006,1.006,0,0,1-.59.62.977.977,0,0,1-.85-.06l-6.21-3.47a1.3,1.3,0,0,0-1-.11L78.01,48.39a3.283,3.283,0,0,1-.98.15ZM61.8,36a1.242,1.242,0,0,0-.56.13,1.265,1.265,0,0,0-.64.74l-.43,1.29a1.331,1.331,0,0,0,.74,1.63l15.62,6.65a1.216,1.216,0,0,0,.88.04l18.67-5.86a3.278,3.278,0,0,1,2.58.27l5.16,2.88,2.54-7.67a1.316,1.316,0,0,0-.82-1.66L88.75,28.69a1.232,1.232,0,0,0-.96.06L73.17,35.77a1.291,1.291,0,0,0-.67,1.54,1.337,1.337,0,0,0,.68.81,1.292,1.292,0,0,0,1.02.06l11.61-4.33a1,1,0,0,1,.7,1.88L74.9,40.06a3.252,3.252,0,0,1-2.61-.14,3.136,3.136,0,0,1-.96-.73l-9.09-3.11a1.234,1.234,0,0,0-.42-.07Z",
    fill: "#74c9e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5",
    "data-name": "Gruppe 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    "data-name": "Pfad 19",
    d: "M15.13,89.33v-4.9h3.06v.74H16v1.27h2.19v.74H16v1.41h2.19v.74H15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_20",
    "data-name": "Pfad 20",
    d: "M19.02,85.14v-.79h.85v.79Zm0,4.2V85.73h.85v3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M21.58,85.73l.04.53a1.4,1.4,0,0,1,1.15-.62,1.181,1.181,0,0,1,.99.46,2.175,2.175,0,0,1,.32,1.35v1.88h-.85V87.52a1.7,1.7,0,0,0-.14-.86.58.58,0,0,0-.55-.27,1.125,1.125,0,0,0-.9.55v2.4h-.85V85.73h.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M28.23,84.43c.82,0,1.79.4,1.79,1.5a1.591,1.591,0,0,1-1.79,1.51h-.65v1.9h-.87v-4.9h1.52Zm-.65,2.26h.49c.6,0,1.04-.2,1.04-.74a.793.793,0,0,0-.9-.78h-.63v1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_23",
    "data-name": "Pfad 23",
    d: "M31.45,86.24a1.066,1.066,0,0,1,.88-.6,1.4,1.4,0,0,1,.43.06l-.19.79a.635.635,0,0,0-.34-.08.851.851,0,0,0-.74.48v2.43h-.85V85.71h.78l.04.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_24",
    "data-name": "Pfad 24",
    d: "M36.57,87.53a1.87,1.87,0,1,1-1.87-1.88A1.841,1.841,0,0,1,36.57,87.53ZM34.7,86.39a1.154,1.154,0,1,0,1.01,1.14A1.06,1.06,0,0,0,34.7,86.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_25",
    "data-name": "Pfad 25",
    d: "M40.66,89.33h-.78l-.04-.46a1.354,1.354,0,0,1-1.13.55,1.9,1.9,0,0,1,.01-3.78,1.493,1.493,0,0,1,1.08.46V84.08h.85v5.25Zm-.85-2.49a1.153,1.153,0,0,0-.92-.46,1.151,1.151,0,0,0-.01,2.29,1.04,1.04,0,0,0,.93-.56V86.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26",
    "data-name": "Pfad 26",
    d: "M44.07,89.33l-.04-.53a1.4,1.4,0,0,1-1.15.62,1.181,1.181,0,0,1-.99-.46,2.175,2.175,0,0,1-.32-1.35V85.73h.85v1.81a1.7,1.7,0,0,0,.14.86.58.58,0,0,0,.55.27,1.125,1.125,0,0,0,.9-.55v-2.4h.85v3.61h-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M47.98,89.33l-.91-1.45-.44.51v.94h-.85V84.08h.85v3.24h.01l1.28-1.6h.99l-1.27,1.49,1.38,2.12H47.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_28",
    "data-name": "Pfad 28",
    d: "M50.32,86.44v1.79c.03.28.13.44.39.44a.877.877,0,0,0,.4-.1l.25.64a1.7,1.7,0,0,1-.78.19,1,1,0,0,1-1.03-.69,2.014,2.014,0,0,1-.09-.67V86.42h-.45v-.71h.45l.09-.83h.76v.83h.95v.71h-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_29",
    "data-name": "Pfad 29",
    d: "M56.93,89.33h-.78l-.04-.46a1.354,1.354,0,0,1-1.13.55,1.9,1.9,0,0,1,.01-3.78,1.493,1.493,0,0,1,1.08.46V84.08h.85v5.25Zm-.85-2.49a1.153,1.153,0,0,0-.92-.46,1.151,1.151,0,0,0-.01,2.29,1.04,1.04,0,0,0,.93-.56V86.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_30",
    "data-name": "Pfad 30",
    d: "M58.46,87.74a1.014,1.014,0,0,0,1.01.98,1.035,1.035,0,0,0,.99-.56l.57.38a1.773,1.773,0,0,1-1.62.87,1.745,1.745,0,0,1-1.81-1.86,1.84,1.84,0,0,1,1.81-1.91,1.615,1.615,0,0,1,1.7,1.67,3.219,3.219,0,0,1-.03.43H58.45Zm.98-1.42a.938.938,0,0,0-.93.81h1.74A.806.806,0,0,0,59.44,86.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_31",
    "data-name": "Pfad 31",
    d: "M62.62,86.24a1.066,1.066,0,0,1,.88-.6,1.4,1.4,0,0,1,.43.06l-.19.79a.635.635,0,0,0-.34-.08.851.851,0,0,0-.74.48v2.43h-.85V85.71h.78l.04.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_32",
    "data-name": "Pfad 32",
    d: "M67.61,85.1c-.41,0-.73.2-.73.57s.48.54.88.67c.72.25,1.53.57,1.53,1.56a1.616,1.616,0,0,1-1.79,1.52,2.458,2.458,0,0,1-1.83-.78l.59-.57a1.672,1.672,0,0,0,1.25.6c.43,0,.87-.21.87-.72,0-.47-.5-.64-1.01-.83-.66-.24-1.35-.56-1.35-1.41a1.388,1.388,0,0,1,1.55-1.37,2.489,2.489,0,0,1,1.58.55l-.51.62a1.65,1.65,0,0,0-1.02-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_33",
    "data-name": "Pfad 33",
    d: "M70.94,86.44v1.79c.03.28.13.44.39.44a.877.877,0,0,0,.4-.1l.25.64a1.7,1.7,0,0,1-.78.19,1,1,0,0,1-1.03-.69,2.014,2.014,0,0,1-.09-.67V86.42h-.45v-.71h.45l.09-.83h.76v.83h.95v.71h-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_34",
    "data-name": "Pfad 34",
    d: "M74.67,89.33l-.04-.34a1.244,1.244,0,0,1-1.02.42,1.166,1.166,0,0,1-1.3-1.13c0-.9.83-1.18,1.59-1.18a3.092,3.092,0,0,1,.68.08V87.1a.682.682,0,0,0-.77-.78,2.328,2.328,0,0,0-1.11.32L72.47,86a3.563,3.563,0,0,1,1.5-.36,1.32,1.32,0,0,1,1.46,1.51v2.18h-.76Zm-.09-1.6a2.427,2.427,0,0,0-.55-.07c-.4,0-.88.13-.88.6,0,.36.29.53.62.53a1.233,1.233,0,0,0,.82-.36v-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_35",
    "data-name": "Pfad 35",
    d: "M77.1,85.73l.04.53a1.4,1.4,0,0,1,1.15-.62,1.181,1.181,0,0,1,.99.46,2.175,2.175,0,0,1,.32,1.35v1.88h-.85V87.52a1.7,1.7,0,0,0-.14-.86.58.58,0,0,0-.55-.27,1.125,1.125,0,0,0-.9.55v2.4h-.85V85.73h.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_36",
    "data-name": "Pfad 36",
    d: "M83.93,89.33h-.78l-.04-.46a1.354,1.354,0,0,1-1.13.55,1.9,1.9,0,0,1,.01-3.78,1.493,1.493,0,0,1,1.08.46V84.08h.85v5.25Zm-.85-2.49a1.153,1.153,0,0,0-.92-.46,1.151,1.151,0,0,0-.01,2.29,1.04,1.04,0,0,0,.93-.56V86.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_37",
    "data-name": "Pfad 37",
    d: "M87.04,89.33,87,88.99a1.244,1.244,0,0,1-1.02.42,1.166,1.166,0,0,1-1.3-1.13c0-.9.83-1.18,1.59-1.18a3.092,3.092,0,0,1,.68.08V87.1a.682.682,0,0,0-.77-.78,2.328,2.328,0,0,0-1.11.32L84.84,86a3.563,3.563,0,0,1,1.5-.36,1.32,1.32,0,0,1,1.46,1.51v2.18h-.76Zm-.09-1.6a2.427,2.427,0,0,0-.55-.07c-.4,0-.88.13-.88.6,0,.36.29.53.62.53a1.233,1.233,0,0,0,.82-.36v-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_38",
    "data-name": "Pfad 38",
    d: "M89.53,86.24a1.066,1.066,0,0,1,.88-.6,1.4,1.4,0,0,1,.43.06l-.19.79a.635.635,0,0,0-.34-.08.851.851,0,0,0-.74.48v2.43h-.85V85.71h.78l.04.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_39",
    "data-name": "Pfad 39",
    d: "M94.58,89.33H93.8l-.04-.46a1.354,1.354,0,0,1-1.13.55,1.9,1.9,0,0,1,.01-3.78,1.493,1.493,0,0,1,1.08.46V84.08h.85v5.25Zm-.85-2.49a1.153,1.153,0,0,0-.92-.46,1.151,1.151,0,0,0-.01,2.29,1.04,1.04,0,0,0,.93-.56V86.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_40",
    "data-name": "Pfad 40",
    d: "M98.87,85.1c-.41,0-.73.2-.73.57s.48.54.88.67c.72.25,1.53.57,1.53,1.56a1.616,1.616,0,0,1-1.79,1.52,2.458,2.458,0,0,1-1.83-.78l.59-.57a1.672,1.672,0,0,0,1.25.6c.43,0,.87-.21.87-.72,0-.47-.5-.64-1.01-.83-.66-.24-1.35-.56-1.35-1.41a1.388,1.388,0,0,1,1.55-1.37,2.489,2.489,0,0,1,1.58.55l-.51.62a1.65,1.65,0,0,0-1.02-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_41",
    "data-name": "Pfad 41",
    d: "M101.76,85.73l.81,2.39h.01l.83-2.39h.92l-2.03,5.25-.76-.29.57-1.52-1.3-3.44h.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_42",
    "data-name": "Pfad 42",
    d: "M106.67,86.6a1.157,1.157,0,0,0-.71-.28c-.25,0-.43.13-.43.35,0,.25.3.37.62.5.46.18,1.05.43,1.05,1.09,0,.8-.66,1.15-1.36,1.15a1.817,1.817,0,0,1-1.37-.6l.52-.49a1.129,1.129,0,0,0,.83.41c.26,0,.54-.13.54-.41,0-.25-.35-.39-.67-.53-.43-.18-.97-.42-.97-1.06a1.112,1.112,0,0,1,1.24-1.09,1.733,1.733,0,0,1,1.19.44l-.48.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_43",
    "data-name": "Pfad 43",
    d: "M108.83,86.44v1.79c.03.28.13.44.39.44a.877.877,0,0,0,.4-.1l.25.64a1.7,1.7,0,0,1-.78.19,1,1,0,0,1-1.03-.69,2.014,2.014,0,0,1-.09-.67V86.42h-.45v-.71h.45l.09-.83h.76v.83h.95v.71h-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_44",
    "data-name": "Pfad 44",
    d: "M110.98,87.74a1.014,1.014,0,0,0,1.01.98,1.035,1.035,0,0,0,.99-.56l.57.38a1.773,1.773,0,0,1-1.62.87,1.745,1.745,0,0,1-1.81-1.86,1.84,1.84,0,0,1,1.81-1.91,1.615,1.615,0,0,1,1.7,1.67,3.219,3.219,0,0,1-.03.43h-2.63Zm.98-1.42a.938.938,0,0,0-.93.81h1.74A.806.806,0,0,0,111.96,86.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_45",
    "data-name": "Pfad 45",
    d: "M118.92,89.33V87.52a1.817,1.817,0,0,0-.13-.86.573.573,0,0,0-.54-.27,1.1,1.1,0,0,0-.83.49,3.632,3.632,0,0,1,.03.58v1.88h-.85V87.53a1.779,1.779,0,0,0-.14-.88.534.534,0,0,0-.5-.25,1.145,1.145,0,0,0-.81.48v2.47h-.85V85.74h.78l.04.48a1.367,1.367,0,0,1,1.08-.57,1.181,1.181,0,0,1,.97.49.87.87,0,0,1,.08.14,1.442,1.442,0,0,1,1.23-.63,1.161,1.161,0,0,1,.97.45,2.205,2.205,0,0,1,.33,1.37v1.88h-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46",
    "data-name": "Pfad 46",
    d: "M121.27,87.74a1.014,1.014,0,0,0,1.01.98,1.035,1.035,0,0,0,.99-.56l.57.38a1.773,1.773,0,0,1-1.62.87,1.745,1.745,0,0,1-1.81-1.86,1.84,1.84,0,0,1,1.81-1.91,1.615,1.615,0,0,1,1.7,1.67,3.219,3.219,0,0,1-.03.43h-2.63Zm.98-1.42a.938.938,0,0,0-.93.81h1.74A.806.806,0,0,0,122.25,86.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47",
    "data-name": "Pfad 47",
    d: "M128.74,87.3v-.74h2.08v1.88a2.566,2.566,0,0,1-2.09.97,2.541,2.541,0,1,1,0-5.08,2.629,2.629,0,0,1,2,.92l-.61.52a1.869,1.869,0,0,0-1.39-.68,1.691,1.691,0,0,0-1.7,1.77,1.641,1.641,0,0,0,1.7,1.77,1.786,1.786,0,0,0,1.22-.48v-.88h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48",
    "data-name": "Pfad 48",
    d: "M136.34,89.33V87.52a1.816,1.816,0,0,0-.13-.86.573.573,0,0,0-.54-.27,1.1,1.1,0,0,0-.83.49,3.632,3.632,0,0,1,.03.58v1.88h-.85V87.53a1.779,1.779,0,0,0-.14-.88.534.534,0,0,0-.5-.25,1.145,1.145,0,0,0-.81.48v2.47h-.85V85.74h.78l.04.48a1.367,1.367,0,0,1,1.08-.57,1.181,1.181,0,0,1,.97.49.87.87,0,0,1,.08.14,1.442,1.442,0,0,1,1.23-.63,1.161,1.161,0,0,1,.97.45,2.205,2.205,0,0,1,.33,1.37v1.88h-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_49",
    "data-name": "Pfad 49",
    d: "M138.95,84.08v2.06a1.422,1.422,0,0,1,1.1-.5,1.9,1.9,0,0,1-.01,3.78,1.429,1.429,0,0,1-1.12-.5l-.04.42h-.77V84.09h.85Zm0,4.14a1.153,1.153,0,0,0,.92.46,1.146,1.146,0,1,0-.93-1.73v1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_50",
    "data-name": "Pfad 50",
    d: "M145.68,89.33V87.18h-2.29v2.15h-.87v-4.9h.87v2.01h2.29V84.43h.87v4.9Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSstPhsLogoRgb);
export default __webpack_public_path__ + "static/media/sst_phs_logo_rgb.c49baf76be86c14d2cbcf51ac826de9b.svg";
export { ForwardRef as ReactComponent };